import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import Button from '../Button';
import { useSelector } from 'react-redux';

function AddSubValPopup({
  masCatId,
  masterId,
  childId,
  closeDialog,
  handleCalbackData,
  catIndex,
  subCatIndex,
  formName,
  heading,
  cat,
  providerId = 0,
  catSubType = '0',
}) {
  const { user } = useSelector((state) => state.auth);

  const [subTypeSection, setSubTypeSection] = useState(
    catSubType === '1' ? true : false,
  );
  const [catagory, setCatagory] = useState(
    childId ? cat.replace(/<br\s*\/?>/gi, '') : '',
  );
  const [radioVal, setRadioVal] = useState('2');
  const [subCalItems, setSubCalItems] = useState([{ name: '' }]);

  useEffect(() => {
    if (catSubType === '1') {
      (async () => {
        try {
          const response = await post(
            'api/patient/progressNote/openTcSubItemPopup',
            {
              schildId: childId, //child id..
              form: formName, //bpsi or therapy
            },
          );
          if (response.status === 200) {
            const childList = response?.data?.childList.map((item) => {
              return { name: item?.itemName };
            });
            setSubCalItems(childList);
            let subValType = response?.data?.childList[0]?.inputType;
            if (subValType === 'checkbox') {
              setRadioVal('2');
            } else if (subValType === 'radio') {
              setRadioVal('1');
            }
          }
        } catch (err) {
          setUiMessage('err', err.message);
        }
      })();
    }
  }, [catSubType, childId, formName]);

  const changeSubTypeSection = (e) => {
    const { checked } = e.target;
    setSubTypeSection(checked);
  };

  const addItem = () => {
    setSubCalItems([...subCalItems, { name: '' }]);
  };

  const removeItem = (index) => {
    const deltedArr = [...subCalItems];
    deltedArr.splice(index, 1);
    setSubCalItems(deltedArr);
  };

  const handleSubCatItems = (val, i) => {
    const onChangeVal = [...subCalItems];
    onChangeVal[i].name = val;
    setSubCalItems(onChangeVal);
  };

  const addTherapyChildData = async () => {
    let subItenArr = subCalItems?.map((item, i) => item?.name).join('#@#');
    let subItenArrChk = subCalItems?.some((item, i) => item?.name === '');
    if (!catagory) {
      if (formName === 'phoneNote') {
        setUiMessage('err', 'Add value is required.');
      } else {
        setUiMessage('err', 'Catagory name is required.');
      }
    } else if (subTypeSection && subItenArrChk) {
      setUiMessage('err', 'Sub catagory values required.');
    } else {
      try {
        const response = await post(
          'api/patient/ProgressNote/addTherapyChildData',
          {
            formName: formName,
            masCatId: masCatId,
            masterId: masterId,
            childId: childId,
            mode: childId ? 'edit' : 'add',
            tcCategory: catagory,
            subCategryCheck: subTypeSection.toString(),
            subItemstr: subTypeSection ? subItenArr : '',
            vals: subTypeSection ? radioVal : '',
            loginUserId: user?.id,
            providerId: providerId,
          },
        );
        if (response.status === 200) {
          if (response.data.successCode === 'success') {
            if (response.data.retVal.length > 0) {
              handleCalbackData(
                response.data.retVal,
                catagory,
                catIndex,
                subCatIndex,
                subTypeSection,
                childId ? 'edit' : 'add',
              );
            } else {
              handleCalbackData('');
            }
          }
          closeDialog();
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    }
  };

  return (
    <div className="modalBackground">
      <div className="sub-type-popup-box">
        <div className="mentalheader-row sub-type-popup-head">
          <span className="sub-type-popup-head-text">
            Add values: {heading}
          </span>
          <Button variant="circle" onClick={closeDialog}>
            X
          </Button>
        </div>
        <div className="mentalvaluemainBody">
          <div
            className="mentalvaluemainBody-row"
            style={{ padding: '10px 0' }}
          >
            {formName === 'phoneNote' ? (
              <div className="menntal-ad-val-text clear-right10 hide">
                Add note:
              </div>
            ) : (
              <div className="menntal-ad-val-text clear-right10">Category:</div>
            )}

            <div className="menntal-ad-val-text-val">
              {/* <div
                contentEditable="true"
                placeholder="Write here..."
                onBlur={(e) => setCatagory(e.target.innerHTML)}
                dangerouslySetInnerHTML={{
                  __html: catagory,
                }}
                className="add-val-inpt"
                style={{
                  border: '1px solid #ccc',
                  width: '100%',
                  height: '200px',
                  padding: '5px',
                  resize: 'none',
                  display: 'inline-block',
                  overflowX: 'hidden',
                  overflowY: 'auto',
                  fontSize: '14px',
                  lineHeight: '21px',
                }}
              /> */}

              <textarea
                id="tcCategory"
                className="add-val-inpt"
                value={catagory}
                onChange={(e) => setCatagory(e.target.value)}
                style={{
                  border: '1px solid #ccc',
                  width: '100%',
                  height: '200px',
                  padding: '5px',
                  resize: 'none',
                }}
              />
            </div>
          </div>
          {formName !== 'phoneNote' && (
            <>
              <div
                className="mentalvaluemainBody-row"
                style={{ display: 'flex', padding: '10px 0' }}
              >
                <div className="menntal-ad-val-text clear-right10">
                  Sub category:
                </div>
                <div
                  className="menntal-ad-val-text-val"
                  style={{ display: 'flex', gap: '80px' }}
                >
                  <input
                    id="subTcCategryCheck"
                    className="selectCheck"
                    type="checkbox"
                    checked={subTypeSection}
                    onChange={(e) => changeSubTypeSection(e)}
                  />
                  <div
                    id="chackTcType"
                    className={
                      subTypeSection
                        ? 'menntal-select-val clear-left10'
                        : 'menntal-select-val hide'
                    }
                    style={{ display: 'flex', gap: '10px' }}
                  >
                    <div className="sbText" style={{ color: '#444444' }}>
                      Type:
                    </div>
                    <div className="sbText">Checkbox</div>
                    <input
                      type="radio"
                      checked={radioVal === '2'}
                      onChange={() => setRadioVal('2')}
                    />
                    <div className="sbText">Radio</div>
                    <input
                      type="radio"
                      checked={radioVal === '1'}
                      onChange={() => setRadioVal('1')}
                    />
                  </div>
                </div>
              </div>
              <div
                className={subTypeSection ? '' : 'hide'}
                style={{ maxHeight: '175px', overflowY: 'auto' }}
              >
                {subCalItems &&
                  subCalItems?.map((item, i) => (
                    <div
                      key={i}
                      className="mentalvaluemainBody-row"
                      style={{ display: 'flex', padding: '10px 0' }}
                    >
                      <span className="menntal-ad-val-text clear-right10">
                        Item:
                      </span>
                      <span
                        className="menntal-ad-val-text-val clear-right10"
                        style={{ display: 'flex', width: '80%' }}
                      >
                        <input
                          id={`newTcTextId_${i}`}
                          className="add-val-inpt"
                          type="text"
                          style={{
                            border: '1px solid #ccc',
                            width: '100%',
                            padding: '5px',
                          }}
                          value={item?.name}
                          onChange={(e) => handleSubCatItems(e.target.value, i)}
                        />
                      </span>
                      {i === 0 ? (
                        <span
                          className=""
                          title="Add Item"
                          onClick={() => addItem()}
                          style={{
                            width: '23px',
                            backgroundColor: '#dadada',
                            padding: '5px 4px 0px 4px',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
                            fontSize: '17px',
                            borderRadius: '15px',
                            height: '23px',
                            cursor: 'pointer',
                          }}
                        >
                          +
                        </span>
                      ) : (
                        <span
                          className="qbutton-submit"
                          title="Add Item"
                          onClick={() => removeItem(i)}
                          style={{
                            width: '23px',
                            backgroundColor: '#dadada',
                            padding: '5px 4px 0px 4px',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
                            fontSize: '17px',
                            borderRadius: '15px',
                            height: '23px',
                            cursor: 'pointer',
                          }}
                        >
                          -
                        </span>
                      )}
                    </div>
                  ))}

                <div className="mentalvaluemainBody-row-apend"></div>
              </div>
            </>
          )}
        </div>
        <div
          className=""
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: ' flex-end',
            width: '100%',
            padding: '5px 10px',
          }}
        >
          <Button
            variant="default"
            onClick={closeDialog}
            style={{ marginRight: '10px' }}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={addTherapyChildData}>
            {childId ? 'Update' : 'Save'}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AddSubValPopup;
